import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import StbForm from "./StbForm";

const StbAdd = () => {
    return (
        <Fragment>
            <StbForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default StbAdd;